import { HandySvg } from "handy-svg";
import style from "./Advantages.module.scss";

export default function Advantages({ dictionary }) {
	const advantages = [
		{
			name: dictionary["save_hundreds_thousands_of_dollars"] || "<b>Save hundreds thousands of dollars</b> on hiring AI experts, improving the accuracy of algorithms and deploying stable services",
			imgUrl: "dollar",
		},
		{ name: dictionary["reduce_months_of_development_process"] || "<b>Reduce months of development process</b> by using ready-made solutions and get quick results", imgUrl: "lamp" },
	];

	return (
		<section className={style.advantages}>
			{advantages.map(({ name, imgUrl }) => (
				<div key={name} className={style.advantage}>
					<HandySvg src={`/application_page/ico/${imgUrl}.svg`} width="60" height="60" fill={"transparent"} />
					<h3 dangerouslySetInnerHTML={{ __html: `${name}` }} />
				</div>
			))}
		</section>
	);
}
